import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/merge-image.webp";

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [pdfToolsOpen, setPdfToolsOpen] = useState(false);
  const [imageToolsOpen, setImageToolsOpen] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [mobileIdCardOpen, setMobileIdCardOpen] = useState(false);
  const [mobilePdfToolsOpen, setMobilePdfToolsOpen] = useState(false);
  const [mobileImageToolsOpen, setMobileImageToolsOpen] = useState(false);

  const idCardOptions = [
    "Aadhar Card Merge",
    "CNIC Card Combine",
    "Passport Merge",
    "Driving License Combine",
    "Student ID Merge",
    "Work ID Merge",
  ];

  const pdfTools = [
    { name: "Merge Multiple PDF", url: "https://imagestopdf.stackasian.com/merge-pdf" },
    { name: "PDF to Images", url: "https://imagestopdf.stackasian.com/merge-pdf" },
    { name: "Images to PDF", url: "https://imagestopdf.stackasian.com/merge-pdf" },
  ];

  const imageTools = [
    { name: "Passport Photo Tool", url: "https://passportphoto.stackasian.com/" },
    { name: "Photo Editor", url: "https://photo-editor.stackasian.com/" },
    { name: "Meme Generator", url: "https://photo-editor.stackasian.com/" },
    { name: "Image Combiner Tool", url: "https://combine-images.stackasian.com/" },
    { name: "Bulk Images to WebP", url: "https://resizeimage.stackasian.com/convert-image/webp" },
    { name: "CNIC Card Combiner", url: "https://resizeimage.stackasian.com/crop-and-merge-two-images" },
  ];

  useEffect(() => {
    if (!mobileMenu) {
      setMobileIdCardOpen(false);
      setMobilePdfToolsOpen(false);
      setMobileImageToolsOpen(false);
    }
  }, [mobileMenu]);

  return (
    <>  <div className="w-full bg-blue-100 text-blue-800 text-sm text-center py-2 px-4 font-medium border-b border-blue-200">
       This website operates exclusively on the frontend, ensuring your images remain secure and private.
      </div>

    <header className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 text-white px-6 py-4 sm:px-10 flex items-center justify-between relative z-50 shadow-md">
      {/* Logo */}
      <Link to="/">
        <img src={logo} alt="Logo" className="h-16 sm:h-24 w-auto" />
      </Link>

      {/* Desktop Nav */}
      <nav className="hidden md:flex gap-10 text-lg font-semibold items-center absolute left-1/2 transform -translate-x-1/2">
        <Link to="/">Home</Link>

            <div>
                            <Link to="/ai-collage-maker">AI Collages</Link>

           </div>
           <div>
                            <Link to="/collages"> Collages</Link>

           </div>
        <div className="relative">
          <button
            className="hover:text-blue-300 transition"
            onClick={() => setIsOpen(!isOpen)}
          >
            ID Card Merge Tool
          </button>
          {isOpen && (
            <div className="absolute left-1/2 -translate-x-1/2 top-full mt-3 w-[400px] bg-white/90 border border-gray-200 rounded-2xl shadow-2xl p-6 text-gray-800">
              <ul>
                {idCardOptions.map((option, index) => (
                  <li key={index} className="mb-2">
                    <Link to="/id-card" className="hover:text-blue-700">
                      {option}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="relative">
          <button
            className="hover:text-blue-300 transition"
            onClick={() => setPdfToolsOpen(!pdfToolsOpen)}
          >
            PDF Tools
          </button>
          {pdfToolsOpen && (
            <div className="absolute left-1/2 -translate-x-1/2 top-full mt-3 w-[400px] bg-white/90 border border-gray-200 rounded-2xl shadow-2xl p-6 text-gray-800">
              <ul>
                {pdfTools.map((tool, index) => (
                  <li key={index} className="mb-2">
                    <a href={tool.url} target="_blank" rel="noopener noreferrer" className="hover:text-blue-700">
                      {tool.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="relative">
          <button
            className="hover:text-blue-300 transition"
            onClick={() => setImageToolsOpen(!imageToolsOpen)}
          >
            Image Tools
          </button>
          {imageToolsOpen && (
            <div className="absolute left-1/2 -translate-x-1/2 top-full mt-3 w-[400px] bg-white/90 border border-gray-200 rounded-2xl shadow-2xl p-6 text-gray-800">
              <ul>
                {imageTools.map((tool, index) => (
                  <li key={index} className="mb-2">
                    <a href={tool.url} target="_blank" rel="noopener noreferrer" className="hover:text-blue-700">
                      {tool.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </nav>

      {/* Mobile Menu Icon */}
      <div className="md:hidden">
        <button onClick={() => setMobileMenu(!mobileMenu)}>
          <span className="material-icons text-white text-3xl">
            {mobileMenu ? "close" : "menu"}
          </span>
        </button>
      </div>

      {/* Mobile Slide-in Menu */}
      {mobileMenu && (
        <div
          className="fixed inset-0 bg-black/50 z-40"
          onClick={() => setMobileMenu(false)}
        >
          <div
            className="absolute top-0 right-0 h-full w-3/4 bg-white text-black shadow-lg p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-bold mb-6">Menu</h2>
            <ul className="space-y-4">
              <li>
                <Link to="/" onClick={() => setMobileMenu(false)}>
                  Home
                </Link>
              </li>

                   <li>
                <Link to="/ai-collage-maker" onClick={() => setMobileMenu(false)}>
                  AI Collages
                </Link>
              </li>
              <li>
                <button
                  className="w-full text-left text-blue-600 font-semibold"
                  onClick={() => setMobileIdCardOpen(!mobileIdCardOpen)}
                >
                  ID Card Merge Tool
                </button>
                {mobileIdCardOpen && (
                  <ul className="pl-4 mt-2 space-y-2">
                    {idCardOptions.map((option, index) => (
                      <li key={index}>
                        <Link to="/id-card">{option}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              <li>
                <button
                  className="w-full text-left text-blue-600 font-semibold"
                  onClick={() => setMobilePdfToolsOpen(!mobilePdfToolsOpen)}
                >
                  PDF Tools
                </button>
                {mobilePdfToolsOpen && (
                  <ul className="pl-4 mt-2 space-y-2">
                    {pdfTools.map((tool, index) => (
                      <li key={index}>
                        <a href={tool.url} target="_blank" rel="noopener noreferrer">
                          {tool.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              <li>
                <button
                  className="w-full text-left text-blue-600 font-semibold"
                  onClick={() => setMobileImageToolsOpen(!mobileImageToolsOpen)}
                >
                  Image Tools
                </button>
                {mobileImageToolsOpen && (
                  <ul className="pl-4 mt-2 space-y-2">
                    {imageTools.map((tool, index) => (
                      <li key={index}>
                        <a href={tool.url} target="_blank" rel="noopener noreferrer">
                          {tool.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </div>
      )}
    </header>
    </>
  );
};

export default Header;
